import type { InterchangeRecords$result, InterchangeRecords$input } from '$houdini'
import { graphql } from '$houdini'

export type InterchangeRecord = InterchangeRecords$result['interchangeRecords']['items'][number]
export type InterchangeLookupFilters = NonNullable<InterchangeRecords$input['filter']>

const interchangeRecordsQuery = graphql(`
	query InterchangeRecords($filter: InterchangeRecordFilter) {
		interchangeRecords(filter: $filter) {
			items {
				id
				interchangeNumber
				subInterchangeNumber
				inventoryType {
					id
				}
				make
				model
				firstYear
				lastYear
				option
				side
				listPrice
				exactApplicationNotes
				inexactApplicationNotes
				#TODO
				#quantityOnHand
				#salesAmount
				#quantitySold
				attachments {
					rank
					public
					file {
						mimetype
						name
						size
						id
						path
					}
				}
			}
		}
	}
`)

export default async function lookupInterchange(filter: InterchangeLookupFilters): Promise<Array<InterchangeRecord>> {
	const computedFilter = filter.interchangeNumber
		? {
				interchangeNumber: filter.interchangeNumber,
				subInterchangeNumber: filter.subInterchangeNumber ?? null,
				inventoryTypeId: filter.inventoryTypeId,
			}
		: filter
	const res = await interchangeRecordsQuery.fetch({ variables: { filter: computedFilter } })
	return res.data?.interchangeRecords.items ?? []
}
